import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { UserDetailsPage } from "~/domain/common";

export function LqsUserDetailsPage() {
  return <UserDetailsPage breadcrumbs={<DataStoreBreadcrumbs />} />;
}
